import ApiService from './api.service';

const GuestbookService = token => {
    const api = ApiService.createApiInstance(token);

    return {
        getResponsesByService(serviceId, params) {
            return api.get(`/guest-book/service/${serviceId}`, { params });
        },
        getResponsesByFuneralHome(funeralHomeId, params) {
            return api.get(`/guest-book/funeral-home/${funeralHomeId}`, { params });
        },
        getResponse(responseId) {
            return api.get(`/guest-book/${responseId}`);
        },
        updateResponseStatus(responseId, status) {
            return api.post(`/guest-book/update-moderated-status/${responseId}/${status}`);
        },
        updateResponseStatusMulti(responseIds, funeralHomeId, status) {
            return api.post(`/guest-book/update-moderated-status-multi/${status}`, responseIds, {
                params: { funeralHomeId },
            });
        },
        deleteResponse(responseId) {
            return api.delete(`/guest-book/${responseId}`);
        },
        getConfigPresets() {
            return api.get(`/guest-book/config-presets`);
        },
    };
};

export default GuestbookService;
